import { Directive, Renderer2, ElementRef, OnInit, DoCheck } from '@angular/core';

@Directive({
  selector: '[appCustomContextMenu]'
})
export class CustomContextMenuDirective implements DoCheck {

  constructor(private renderer: Renderer2, private elementRef: ElementRef) { }

  ngDoCheck() {
    const element = this.elementRef.nativeElement;
    const contextMenuSelected = element.getElementsByClassName('p-contextmenu-selected');
    const contextMenu = document.getElementsByClassName('p-contextmenu');
    if (contextMenuSelected[0]) {
      this.renderer.addClass(contextMenuSelected[0], 'p-contextmenu-focused');
    }

    if (contextMenuSelected[0] && ((contextMenu[0] as HTMLElement).style.display === 'none')) {
      contextMenuSelected[0].classList.remove('p-contextmenu-focused');
    }
  }

}
